import { useCustomField } from 'components/custom-fields/CustomFieldForm';
import { toFriendlyType } from 'components/custom-fields/helpers';
import * as Form from 'components/form';

const CustomFieldCheckboxForm = () => {
    const methods = Form.useGivebutterFormContext();
    const { control, getValues } = methods;
    const { getFormFieldPath } = useCustomField();

    const typePath = getFormFieldPath('type');
    const defaultPath = getFormFieldPath('defaultResponse');

    const type = getValues(typePath);
    if (toFriendlyType(type) !== 'checkbox') {
        return null;
    }

    return (
        <Form.Container className={'gap-y-1.5'}>
            <div className={'flex justify-between gap-x-4'}>
                <Form.UseFormCheckboxInput name={defaultPath} control={control} />

                <div className={'flex flex-grow flex-col gap-y-1'}>
                    <Form.Label name={defaultPath} className={'cursor-pointer leading-none'}>
                        Default checkbox state
                    </Form.Label>
                    <p className={'text-sm text-gray-600'}>
                        Defaults the response to checked or unchecked.
                    </p>
                </div>
            </div>
            <Form.UseFormError name={defaultPath} />
        </Form.Container>
    );
};

const Checkbox = CustomFieldCheckboxForm;

export { CustomFieldCheckboxForm, Checkbox };
